import React from 'react'
import { Heading, HeadingLevel } from 'baseui/heading'
import { Grid, Cell } from 'baseui/layout-grid'

import SEO from '~/components/Seo'
import ProductCard from '~/components/ProductCard'
import CollectionCard from '~/components/CollectionCard'

const IndexPage = ({ data }) => {
  if (!data) return <p>Error loading products...</p>

  return (
    <>
      <SEO title="Home" keywords={[`gatsby`, `application`, `react`]} />
      <Grid gridGaps={20} gridMaxWidth={'100%'}>
        <Cell span={[4, 8, 12]}>
          <HeadingLevel>
            <Heading styleLevel={4}>
              Choose an <strong>Aussie Care Package</strong> or{' '}
              <strong>Build Your Own!</strong>
            </Heading>
          </HeadingLevel>
        </Cell>
        {data.build &&
          data.build.products.map(product => (
            <Cell key={product.id} span={[4, 3, 4]}>
              <ProductCard product={product} />
            </Cell>
          ))}

        <Cell span={[4, 3, 4]}>
          {data.premade && <CollectionCard collection={data.premade} />}
        </Cell>
      </Grid>
    </>
  )
}

export default IndexPage

export const query = graphql`
  query {
    build: shopifyCollection(handle: { eq: "build-your-own" }) {
      id
      title
      handle
      descriptionHtml
      image {
        localFile {
          childImageSharp {
            fluid(maxWidth: 910) {
              ...GatsbyImageSharpFluid_withWebp_tracedSVG
            }
          }
        }
      }
      products {
        id
        title
        handle
        tags
        productType
        description
        descriptionHtml
        shopifyId
        options {
          id
          name
          values
        }
        variants {
          id
          title
          price
          availableForSale
          shopifyId
          selectedOptions {
            name
            value
          }
        }
        priceRange {
          minVariantPrice {
            amount
            currencyCode
          }
          maxVariantPrice {
            amount
            currencyCode
          }
        }
        images {
          originalSrc
          id
          localFile {
            childImageSharp {
              fluid(maxWidth: 910) {
                ...GatsbyImageSharpFluid_withWebp_tracedSVG
              }
            }
          }
        }
      }
    }
    premade: shopifyCollection(handle: { eq: "select-from-our-range" }) {
      id
      title
      handle
      descriptionHtml
      image {
        localFile {
          childImageSharp {
            fluid(maxWidth: 910) {
              ...GatsbyImageSharpFluid_withWebp_tracedSVG
            }
          }
        }
      }
      products {
        id
        title
        handle
      }
    }
  }
`
